var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "currentColor",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.297 14.893a8 8 0 1 1 2.829-2.828l2.298 2.299a2 2 0 1 1-2.828 2.828l-2.3-2.299Zm-1.255-4.046.037-.037a4 4 0 1 0-.037.037",
  clipRule: "evenodd"
})));
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8dGl0bGU+U2VhcmNoPC90aXRsZT4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yOTcgMTQuODkzYTggOCAwIDEgMSAyLjgyOS0yLjgyOGwyLjI5OCAyLjI5OWEyIDIgMCAxIDEtMi44MjggMi44MjhsLTIuMy0yLjI5OVptLTEuMjU1LTQuMDQ2YTEuNTcgMS41NyAwIDAgMSAuMDM3LS4wMzcgNCA0IDAgMSAwLS4wMzcuMDM3WiIvPjwvc3ZnPg==";